const isEmptyValue = (value) => value === null || value === undefined || value === '';
const isInvalidNumber = (value) => isEmptyValue(value) || !/[0-9]$/.test(String(value));
export const defaultValueToNullIfEmpty = (value, defaultValue) => {
    if (!isEmptyValue(value)) {
        return String(value);
    }
    return !isEmptyValue(defaultValue) ? Number(defaultValue) : '';
};
export const defaultValueToNullIfInvalidNumber = (value) => (isInvalidNumber(value) ? null : Number(value));
export const normalizeValue = (value) => {
    const valueWithDotDecimalSeparator = value.replace(',', '.');
    if (isInvalidNumber(valueWithDotDecimalSeparator)) {
        return valueWithDotDecimalSeparator;
    }
    // Preserve minus sign when typing '-00'.
    return valueWithDotDecimalSeparator.startsWith('-')
        ? valueWithDotDecimalSeparator.replace(/^-0+(?!\.|,|$)/, '-')
        : valueWithDotDecimalSeparator.replace(/^0+(?!\.|,|$)/, '');
};
export const isInRange = ({ value, minValue, maxValue, }) => !(!Number.isNaN(minValue) && value < Number(minValue)) &&
    !(!Number.isNaN(maxValue) && value > Number(maxValue));
export const getErrorMessageByLocale = () => 'Invalid Value';
export const getHasError = ({ value, minValue, maxValue, }) => !isEmptyValue(value) &&
    (isInvalidNumber(value) ||
        !isInRange({
            value: Number(value),
            minValue,
            maxValue,
        }));
//# sourceMappingURL=index.js.map